import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/')({
  loader: () => {
    throw redirect({
      to: `/welcome`,
    })
  },
})
